import { getResponsiveAttributes } from '../internal/utils/getResponsiveAttributes.js';
import classes from './Stack.module.css.js';
import { clsx } from 'clsx';
import { toggleSxComponent } from '../internal/utils/toggleSxComponent.js';
import { jsx } from 'react/jsx-runtime';

const StackBaseComponent = toggleSxComponent('div');
function Stack({
  as,
  children,
  align = 'stretch',
  direction = 'vertical',
  gap,
  justify = 'start',
  padding = 'none',
  wrap = 'nowrap',
  className,
  ...rest
}) {
  return /*#__PURE__*/jsx(StackBaseComponent, {
    as: as,
    ...rest,
    className: clsx(className, classes.Stack),
    ...getResponsiveAttributes('gap', gap),
    ...getResponsiveAttributes('direction', direction),
    ...getResponsiveAttributes('align', align),
    ...getResponsiveAttributes('wrap', wrap),
    ...getResponsiveAttributes('justify', justify),
    ...getResponsiveAttributes('padding', padding),
    children: children
  });
}
Stack.displayName = "Stack";
const StackItemBaseComponent = toggleSxComponent('div');
function StackItem({
  as,
  children,
  grow,
  className,
  ...rest
}) {
  return /*#__PURE__*/jsx(StackItemBaseComponent, {
    as: as,
    ...rest,
    className: clsx(className, classes.StackItem),
    ...getResponsiveAttributes('grow', grow),
    children: children
  });
}
StackItem.displayName = "StackItem";

export { Stack, StackItem };
